// Iter 537 — Helper murni untuk grouping events Riwayat per-produk dalam satu nota.
//   Dipisahkan dari komponen UI supaya mudah diuji secara perilaku (behavioral test).
//
// Kontrak input (events untuk 1 nota):
//   events: Array<{
//     order:   { order_number: string, ...},
//     product: { id?: string, product_id?: string, name?: string, custom_name?: string,
//                color?: string, quantity?: number, qty?: number, ... },
//     event:   { at?: string, stage_from?: string, handed_over_by?: string, moved_by?: string, ... },
//     isRevert?: boolean,
//     isCanceled?: boolean,
//     isAcc?: boolean,
//     ...
//   }>
//
// Kontrak output (deterministik):
//   Array<{
//     identity: string,              // kunci grouping
//     primary:  <event terbaru>,     // untuk header kartu
//     all:      Array<event>,        // SEMUA event untuk produk ini, desc by at
//   }>
//   Diurutkan desc berdasarkan waktu event terbaru per produk.
//
// Prinsip:
//   - Identitas prioritas: product.id → product.product_id → fallback name|color|qty.
//   - Fallback mencegah dua produk BERBEDA (nama/warna/qty berbeda) ter-merge ketika id kosong.
//   - TIDAK membuang event (semua event tetap ada di `all`).
//   - Tidak mengubah data input (pure function).

function _identity(product) {
  const p = product || {};
  if (p.id) return `id::${p.id}`;
  if (p.product_id) return `pid::${p.product_id}`;
  const name = p.custom_name || p.name || "?";
  const color = p.color || "";
  const qty = p.quantity != null ? p.quantity : (p.qty != null ? p.qty : "");
  return `fb::${name}::${color}::${qty}`;
}

function _cmpAtDesc(a, b) {
  const ax = (a && a.event && a.event.at) || "";
  const bx = (b && b.event && b.event.at) || "";
  // localeCompare terbalik → desc
  return bx.localeCompare(ax);
}

export function groupRiwayatByProduct(events) {
  if (!Array.isArray(events) || events.length === 0) return [];
  const buckets = new Map();
  for (const it of events) {
    if (!it) continue;
    const key = _identity(it.product);
    if (!buckets.has(key)) buckets.set(key, []);
    buckets.get(key).push(it);
  }
  const perProduct = [];
  for (const [identity, evts] of buckets.entries()) {
    const sorted = [...evts].sort(_cmpAtDesc);
    perProduct.push({ identity, primary: sorted[0], all: sorted });
  }
  perProduct.sort((a, b) => _cmpAtDesc(a.primary, b.primary));
  return perProduct;
}

// Diekspos untuk kebutuhan test & debugging.
export const __riwayat_grouping_internal__ = { _identity, _cmpAtDesc };
